import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledPinnacleDatePicker = styled(DatePicker)(({ theme }) => ({
  '& .MuiPickersInputBase-root': {
    color: theme.palette.common.white,
    '& fieldset': {
      borderColor: 'var(--form-gray-fieldset)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'var(--form-gray-fieldset) !important',
    },
  },
  '& .MuiPickersOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'var(--form-gray-fieldset)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'var(--form-gray-fieldset)',
    },
    '& input': {
      color: theme.palette.common.white,
    },
    '&.Mui-disabled *': {
      color: 'var(--form-gray-fieldset) !important',
      WebkitTextFillColor: 'var(--form-gray-fieldset)',
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.common.white,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.common.white,
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: theme.palette.common.white,
  },
  '& .MuiFormHelperText-root': {
    color: theme.palette.common.white,
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: 'var(--form-error-helper)',
  },
}));
